var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: !_vm.dataLoaded,
      expression: "!dataLoaded"
    }]
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Управление сроками"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1)], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.localBlockTriggerParent.list,
      "filter": ""
    },
    scopedSlots: _vm._u([{
      key: "item.submissionSession",
      fn: function fn(_ref) {
        var _item$submissionSessi, _item$submissionSessi2, _item$submissionSessi3, _item$submissionSessi4;

        var item = _ref.item;
        return [_vm._v(" " + _vm._s("".concat((_item$submissionSessi = item.submissionSession) === null || _item$submissionSessi === void 0 ? void 0 : (_item$submissionSessi2 = _item$submissionSessi.semester) === null || _item$submissionSessi2 === void 0 ? void 0 : _item$submissionSessi2.name, " ").concat((_item$submissionSessi3 = item.submissionSession) === null || _item$submissionSessi3 === void 0 ? void 0 : (_item$submissionSessi4 = _item$submissionSessi3.year) === null || _item$submissionSessi4 === void 0 ? void 0 : _item$submissionSessi4.name)) + " ")];
      }
    }, {
      key: "item.startDate",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.startDateFunc(item)) + " ")];
      }
    }, {
      key: "item.startTime",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.startTimeFunc(item)) + " ")];
      }
    }, {
      key: "item.endDate",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.endDateFunc(item)) + " ")];
      }
    }, {
      key: "item.endTime",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.endTimeFunc(item)) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil-outline ")]), _c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }])
  })], 1), _c('DeadlinePageDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "loading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem
    },
    on: {
      "saveBlockTrigger": _vm.saveDeadline,
      "closeModal": _vm.closeDialog
    }
  }), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430?"
    },
    on: {
      "confirm": _vm.removeDeadline,
      "closeModal": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }